export default {
	description: {
		banner_text: 'https://web-data.zmlearn.com/image/jjgHak4UHF6c3iLTtNoWhh/iimg_banner%402x.png',
	},
	tags: {
		list: [
			{
				img: 'https://web-data.zmlearn.com/image/eMLPq9U34Riey56hHrqu88/icon_P1_investments%402x.png',
				total: '$400M',
				desc: 'INVESTMENTS',
			},
			{
				img: 'https://web-data.zmlearn.com/image/hWjNSFTZU48ucLUaw2TDqP/icom_p1_students%402x.png',
				total: '500,000+',
				desc: 'STUDENTS',
			},
			{
				img: 'https://web-data.zmlearn.com/image/dE2CYcwTecYLx7vet4eMK/icon_p1_tutors%402x.png',
				total: '10,000+',
				desc: 'TUTORS',
			},
			{
				img: 'https://web-data.zmlearn.com/image/vrsmdWYGS6gFd3Z3n9PDHd/icon_p1_employees%402x.png',
				total: '2,000+',
				desc: 'EMPLOYEES',
			},
			{
				img: 'https://web-data.zmlearn.com/image/6kNkY5zJu9QQyuMm8dm6xg/icon_P1_subjects%402x.png',
				total: '30+',
				desc: 'SUBJECTS',
			},
			{
				img: 'https://web-data.zmlearn.com/image/qr3TLq4gzGZyXNPf963dMZ/icon_P1_countries%402x.png',
				total: '35+',
				desc: 'COUNTRIES',
			},
			{
				img: 'https://web-data.zmlearn.com/image/2o1FRQSZUXigQNypLtDjKi/%E7%BC%96%E7%BB%84%206%402x.png',
				total: '$400',
				desc: 'million USD',
			},
		],
	},
	partners: {
		title: `<h1>BUILD <span> No.1 GLOBAL</span> ONLINE<br/>SCHOOL WITH US</h1>`,
		p1: `By now, AirClass is global online tutoring institution with<p> over 500,000 students </p>worldwide and over <span>10,000 experienced tutors</span>. Our mission is to provide quality tutoring at any time and any place.`,
		p2: `In 2021, 91% of the students surveyed have improved significantly after undergoing 3 months of academic tutoring.`,
		list: [
			{
				img: 'https://web-data.zmlearn.com/image/3xoqn3UKs8RRi17ZygqKNj/img_p2_zoom%402x.png',
				name: 'zoom',
			},
			{
				img: 'https://web-data.zmlearn.com/image/44jdHKj16PHw63m4EgjDiD/img_p2-goole%402x.png',
				name: 'google',
			},
			{
				img: 'https://web-data.zmlearn.com/image/cj7s8CjwEy5ckDkBmQVsDH/img_p2_stripe%402x.png',
				name: 'stripe',
			},
			{
				img: 'https://web-data.zmlearn.com/image/rqe7nvjQUHgUZmpr1WBCSS/img_p2_alipay%402x.png',
				name: 'alipay',
			},
			{
				img: 'https://web-data.zmlearn.com/image/5X2ZaP99MnrjNVZJZykamA/img_p2_facebook%402x.png',
				name: 'facebook',
			},
			{
				img: 'https://web-data.zmlearn.com/image/eMf8MPAFiwUpbcrKXSPvHV/img_p2_ins%402x.png',
				name: 'instagram',
			},
		],
	},
	team: {
		title: `<h1>Our <span>Team</span></h1>`,
		list: [
			{
				img: 'https://web-data.zmlearn.com/image/kxY9ZTr5KwwiejRY116Xt6/img_p3-1%402x.png',
				desc: `Our leader team believe that eaducation is a human right that we should make our students can connect experienced tutors in any subject, anywhere, anytime. We want to build solid team, think big, insist on High Standards and deliver Results.`,
			},
			{
				img: 'https://web-data.zmlearn.com/image/pdUSGJCezf7q4tapcMm5tL/img_p3_2%402x.png',
				desc: `Our curriculum team is organized by areas of  expertise.Team members have backgrounds in classroom  teaching, school administration, high-stakes  testing, higher education, and online curriculum  development.  The unique experiences and skill sets of each team member help provide us with a diverse perspective on education and help to build a team that is highly collaborative, always striving  for excellence, and fun.`,
			},
		],
	},
	feature: {
		title: `<h1>Our product<span> features</span></h1>`,
		list: [
			{
				icon: 'https://web-data.zmlearn.com/image/cvQcrgF4gHmJF8qn1AVVLF/icon_P5_1%402x.png',
				title: '1-on-1 expert online tutoring',
				backgroundColor: '#FFD3B4',
			},
			{
				icon: 'https://web-data.zmlearn.com/image/kAK4Jgr2bRtds7gCqQ3WUo/img_p5_2%402x.png',
				title: 'Real-time interactive online tutoring tool',
				backgroundColor: '#FFDADF',
			},
			{
				icon: 'https://web-data.zmlearn.com/image/gQfpqv5xKPZf8HrHG8n4Xg/img_p5_3%402x.png',
				title: '30+ school subjects including maths and sciences',
				backgroundColor: '#B8F2E1',
			},
			{
				icon: 'https://web-data.zmlearn.com/image/qoT8UYcCvYV4PGxdVzUmuo/img_p5_4%402x.png',
				title: `Always keeping an eye on students' progress and matching the best tutor for students`,
				backgroundColor: '#FEEFC0',
			},
		],
	},
	faqs: {
		title: `<h1><p>Interested</p>&nbsp;in&nbsp;<span>partnering</span>?</h1>`,
		desc: `Please email us and trell us your motivation`,
		desc2: `More details please contact us at <img src="{img}" alt=""/> bd@air-class.com`,
		q: '',
		list: [
			{
				question: 'Join AirClass Affiliate Program to be our Partners.',
				answer: `At present, AirClass 1-on-1 has served many countries in Europe, North America, the Middle East and Southeast Asia. Based on our good reputation among users, we have accumulated more than 10,000 teachers and more than 500,000 paying students all over the world. Now the company's business is expanding rapidly. We expect more and more excellent talents to join us and create a better future!
				<br/>
				<span>AirClass Affiliate Program</span>
				Join AirClass Affiliate Program to get the highest commission of the market of Education and eLearning and make money by bringing high quality education to your audience.
				<br/>
				<span>What your audience can expect from us?</span>
				<i>1-1 online lessons from £15/hr</i>
				<br/>
				<i>Unique tailored 1-on-1 learning plan</i>
				<br/>
				<i>Exclusive 1-on-1 virtual classroom developed for our students and tutors, and features everything they need for a smooth, interactive learning experience</i>
				<br/>
				<i>An experienced, qualified tutor community </i>
				<br/>
				<i>Handpicked expert tutors graduated from well-known QS top ranking universities as Ivy League school in US and G5 in UK</i>
				<br/>
				<i>Meet tutors for a 45 min free trial lesson before purchasing lessons</i>
				<br/>
				<span>Who we are welcoming to join us as partner?</span>
				<i>Social Media Influencers (parents/ teachers)</i>
				<br/>
				<i>Bloggers (parents/ teachers)</i>
				<br/>
				<i>Tutors</i>
				<br/>
				<i>Schools/ Institutes</i>
				<br/>
				<i>Country Agents</i>
				<br/>
				<i>SME/ Startup</i>
				<br/>
				<i>Publishers</i>
				<br/>
				<i>Others</i>
				<span>Why choose to partner with us?</span>
				<i>High quality marketing tools</i>
				<br/>
				Our program will provide you with the best marketing tools designed by our creative studio – various design and size banner options for all of our tutoring services, as well as dedicated emails with engaging content, ready to be sent to your list.
				<br/>
				<i>Boosting online learning market</i>
				<br/>
				Since the Covid-19 and all the disruption to education, parents are increasingly willing to provide support to their children via online tutoring. Online learning is soaring, we’re fostering both sides of the marketplace.
				<br/>
				<i>Competitive Revenue boost</i>
				<br/>
				High commission for every new registration (leads) you drive that books their first free trial lesson with us. Start growing your revenue by referring students and parents to our platform. It’s that simple!
				<br/>
				<br/>
				*We also offer you a tier program, where you can earn from sales made by affiliates referred by you! We are continually accepting applications to our affiliate program now. The AirClass Affiliate Program includes both online and direct sales channel opportunities.
				<br/>
				`,
			},
			{
				question: 'Are you a school, nursery or any other academic institution?',
				answer: `<span>School and Preschool Partnership Program</span>
								Partner with AirClass to provide academic support to your students on their school
								<br/>
								performance and to provide more preschool learnings for your kids in early ages. We partner with public, private, charter, cyber and independent schools to provide online.
								<br/>
								tutoring services for students in preschool and Year 1-13. We’ve worked hard to develop an effective tutoring model with proven impact.
								<br/>
								<span>Why choose to business with us?</span>
								<p>Convenience</p>
								Whether services are needed during the school day, after school hours or at the student’s home, AirClass online tutoring service will all work for you 1-on-1 or in group. This works out great for parents who can’t schedule tutoring sessions in their home due to an overloaded schedule.
								<br/>
								<p>Affordability</p>
								We offer the highest quality of individualized tutoring at an affordable price. We believe that you should not have to pay for expensive academic support.
								<br/>
								<p>Individualized Instruction</p>
								Our unique program offers 1-on-1 or small group tutoring. Our certified teachers tailor each lesson to the individual student’s level and needs. Individualized instruction results in an increase in self-esteem, better grades and a greater willingness to learn.
								<br/>
								<p>Enrichment Classes</p>
								We not only specialize in tutoring, we offer interactive enrichment classes. For example, drawing, coding,music and so on. We can partner with your school and implement one of our many enrichment programs.
								`,
			},
			{
				question: 'Are you an employer or the employee benefits manager ?',
				answer: `<span>AirClass Corporate Benefit Program</span>
								AirClass Corporate Benefit Program offers your company’s staff an exceptional family educational benefit at affordable cost to your staff. Give your employees and their families access to our preschool and school performance improvement 1-on-1 tutoring services, reduce the stress and burden of them, guarantee higher scores after taking our programe.We tailor our program to your needs. A benefit package enriched with AirClass services helps you recruit and retain employees, and be an employer of choice.
								<br/>
								Our tutors are experts in 1-on-1 online tuition across a huge range of subjects and levels, from primary, through to MCAT, GCSE, A-Level, SAT and beyond to degree level. And Our tutors will help the students to improve their grades with lessons that match their needs and learning goals. Your employees will get rid of being struggling with kids' study and more focus on working.
								<br/>
								<span>Why choose to business with us?</span>
								<p>Convenience</p>
								Online lessons mean your employees can access to the study sessions for their children at home, after working hours or on the weekend. Anytime, anywhere. And we will Manage all administrative details associated with your program
								<br/>
								<p>Flexibility</p>
								Our 50,000 high-quality teachers ensure around the clock availability for the right type of lesson to meet your team's needs.
								<br/>
								<p>Affordability</p>
								Our low fees and competitive marketplace ensure you'll find the right teacher for your staff at the right price.`,
			},
			{
				question: 'Are you a content creator or influencer?',
				answer: `<span> AirClass's Sponsorships Program</span>
				We would love to sponsor your content and introduce AirClass to your audiences on YouTube, podcast, or other media channels. We offer incentives in the form of free lessons and paid sponsorship.
				<br/>
				<span>Why choose to partner with us?</span>
				AirClass works with selected content creators to offer sponsorship based on your channel's performance. When you join our program you'll get:
				<br/>
				A landing page with a unique tracking URL;
				<br/>
				Free lessons for you to choose any tutor and any subjects to try with AirClass;
				<br/>
				Fast and easy setup;
				<br/>
				An Account Manager;
				<br/>
				Scheduled monthly payments;
				<br/>
				A special promotion for your viewers.`,
			},
		],
		button: 'Apply to Brand Now',
	},
	modal: {
		title: 'What we can offer',
		list: [
			{
				question: `Refer. Trial. Earn. <img width="{size}" height="{size}" src="https://web-data.zmlearn.com/image/6AeEF4kQ4QeUpmd8oL5kyj/icon_good%402x.png"/>`,
				answer: `At present, AirClass 1-on-1 has served many countries in Europe, North America, the Middle East and Southeast Asia. Based on our good reputation among users, we have accumulated more than 10,000 teachers and more than 500,000 paying students all over the world. Now the company's business is expanding rapidly. We expect more and more excellent talents to join us and create a better future!
				<br/>
				<span>AirClass Affiliate Program</span>
				Join AirClass Affiliate Program to get the highest commission of the market of Education and eLearning and make money by bringing high quality education to your audience.
				<br/>
				<span>What your audience can expect from us?</span>
				<i>1-1 online lessons from £15/hr</i>
				<br/>
				<i>Unique tailored 1-on-1 learning plan</i>
				<br/>
				<i>Exclusive 1-on-1 virtual classroom developed for our students and tutors, and features everything they need for a smooth, interactive learning experience</i>
				<br/>
				<i>An experienced, qualified tutor community </i>
				<br/>
				<i>Handpicked expert tutors graduated from well-known QS top ranking universities as Ivy League school in US and G5 in UK</i>
				<br/>
				<i>Meet tutors for a 45 min free trial lesson before purchasing lessons</i>
				<br/>
				<span>Who we are welcoming to join us as partner?</span>
				<i>Social Media Influencers (parents/ teachers)</i>
				<br/>
				<i>Bloggers (parents/ teachers)</i>
				<br/>
				<i>Tutors</i>
				<br/>
				<i>Schools/ Institutes</i>
				<br/>
				<i>Country Agents</i>
				<br/>
				<i>SME/ Startup</i>
				<br/>
				<i>Publishers</i>
				<br/>
				<i>Others</i>
				<span>Why choose to partner with us?</span>
				<i>High quality marketing tools</i>
				<br/>
				Our program will provide you with the best marketing tools designed by our creative studio – various design and size banner options for all of our tutoring services, as well as dedicated emails with engaging content, ready to be sent to your list.
				<br/>
				<i>Boosting online learning market</i>
				<br/>
				Since the Covid-19 and all the disruption to education, parents are increasingly willing to provide support to their children via online tutoring. Online learning is soaring, we’re fostering both sides of the marketplace.
				<br/>
				<i>Competitive Revenue boost</i>
				<br/>
				High commission for every new registration (leads) you drive that books their first free trial lesson with us. Start growing your revenue by referring students and parents to our platform. It’s that simple!
				<br/>
				<br/>
				*We also offer you a tier program, where you can earn from sales made by affiliates referred by you! We are continually accepting applications to our affiliate program now. The AirClass Affiliate Program includes both online and direct sales channel opportunities.
				<br/>
				`,
			},
			{
				question: 'Are you a School, Nursery or any other academic institution?',
				answer: `<span>School and Preschool Partnership Program</span>
								Partner with AirClass to provide academic support to your students on their school
								<br/>
								performance and to provide more preschool learnings for your kids in early ages. We partner with public, private, charter, cyber and independent schools to provide online.
								<br/>
								tutoring services for students in preschool and Year 1-13. We’ve worked hard to develop an effective tutoring model with proven impact.
								<br/>
								<span>Why choose to business with us?</span>
								<p>Convenience</p>
								Whether services are needed during the school day, after school hours or at the student’s home, AirClass online tutoring service will all work for you 1-on-1 or in group. This works out great for parents who can’t schedule tutoring sessions in their home due to an overloaded schedule.
								<br/>
								<p>Affordability</p>
								We offer the highest quality of individualized tutoring at an affordable price. We believe that you should not have to pay for expensive academic support.
								<br/>
								<p>Individualized Instruction</p>
								Our unique program offers 1-on-1 or small group tutoring. Our certified teachers tailor each lesson to the individual student’s level and needs. Individualized instruction results in an increase in self-esteem, better grades and a greater willingness to learn.
								<br/>
								<p>Enrichment Classes</p>
								We not only specialize in tutoring, we offer interactive enrichment classes. For example, drawing, coding,music and so on. We can partner with your school and implement one of our many enrichment programs.
								`,
			},
			{
				question: 'Are you an employer looking for ways to enhance your employee benefits?',
				answer: `<span>AirClass Corporate Benefit Program</span>
								AirClass Corporate Benefit Program offers your company’s staff an exceptional family educational benefit at affordable cost to your staff. Give your employees and their families access to our preschool and school performance improvement 1-on-1 tutoring services, reduce the stress and burden of them, guarantee higher scores after taking our programe.We tailor our program to your needs. A benefit package enriched with AirClass services helps you recruit and retain employees, and be an employer of choice.
								<br/>
								Our tutors are experts in 1-on-1 online tuition across a huge range of subjects and levels, from primary, through to MCAT, GCSE, A-Level, SAT and beyond to degree level. And Our tutors will help the students to improve their grades with lessons that match their needs and learning goals. Your employees will get rid of being struggling with kids' study and more focus on working.
								<br/>
								<span>Why choose to business with us?</span>
								<p>Convenience</p>
								Online lessons mean your employees can access to the study sessions for their children at home, after working hours or on the weekend. Anytime, anywhere. And we will Manage all administrative details associated with your program
								<br/>
								<p>Flexibility</p>
								Our 50,000 high-quality teachers ensure around the clock availability for the right type of lesson to meet your team's needs.
								<br/>
								<p>Affordability</p>
								Our low fees and competitive marketplace ensure you'll find the right teacher for your staff at the right price.`,
			},
			{
				question: 'Are you a content creator or influencer?',
				answer: `<span> AirClass's Sponsorships Program</span>
				We would love to sponsor your content and introduce AirClass to your audiences on YouTube, podcast, or other media channels. We offer incentives in the form of free lessons and paid sponsorship.
				<br/>
				<span>Why choose to partner with us?</span>
				AirClass works with selected content creators to offer sponsorship based on your channel's performance. When you join our program you'll get:
				<br/>
				A landing page with a unique tracking URL;
				<br/>
				Free lessons for you to choose any tutor and any subjects to try with AirClass;
				<br/>
				Fast and easy setup;
				<br/>
				An Account Manager;
				<br/>
				Scheduled monthly payments;
				<br/>
				A special promotion for your viewers.`,
			},
		],
	},
	toTop: 'https://web-data.zmlearn.com/image/6y4pwqWp26Me7Qd8K4k8Q/img_home_backtotop%402x.png',
};
